<template>
	<div>
		<!--===================== EDITING =====================-->
		<div v-if = "editing" >
			<div class = "mb3">
				<router-link :to = "'/' + $route.params.businessID + '/manager/setting'" >
					<button class = "btn">Back to Setting</button>
				</router-link>
				<button class = "btn btn-md btn-gradient-success"@click = "editSubmit" >Update</button>
			</div>
			<table class = "table table-bordered">
				<tbody>
					<tr>
						<th>Setting</th>
						<td>
							<table class="table table-bordered">
								<tbody>
									<tr>
										<th>
											Min Delivery Distance (km)
										</th>
										<td>
											<input @input = "calcFee" type = "number" class = "form_control" placeholder = "Min Delivery Distance" v-model = "editForm['Min Delivery Distance']">
											<p class = "font-red">{{errorMsg["Min Delivery Distance"]}}</p>
										</td>
									</tr>
									<tr>
										<th>
											Max Delivery Distance (km)
										</th>
										<td>
											<input @input = "calcFee" type = "number" class = "form_control" placeholder = "Max Delivery Distance" v-model = "editForm['Max Delivery Distance']">
											<p class = "font-red">{{errorMsg["Max Delivery Distance"]}}</p>
										</td>
									</tr>
									<tr>
										<th>
											Delivery Fee (RM)
										</th>
										<td>
											<input @input = "calcFee" type = "number" class = "form_control" placeholder = "Delivery Fee" v-model = "editForm['Delivery Fee']">
											<p class = "font-red">{{errorMsg["Delivery Fee"]}}</p>
										</td>
									</tr>
									<tr>
										<th>
											Delivery Rate (RM/km)
										</th>
										<td>
											<input @input = "calcFee" type = "number" class = "form_control" placeholder = "Delivery Rate" v-model = "editForm['Delivery Rate']">
											<p class = "font-red">{{errorMsg["Delivery Rate"]}}</p>
										</td>
									</tr>
									<tr>
										<th>
											Minimum Order (RM)
											<br>
											(Reduced Delivery Fee)
										</th>
										<td>
											<input @input = "calcFee" type = "number" class = "form_control" placeholder = "Minimum Order" v-model = "editForm['Minimum Order']">
											<p class = "font-red">{{errorMsg["Minimum Order"]}}</p>
										</td>
									</tr>
									<tr>
										<th>
											Deduction Amount (RM)
											<br>
											(How much to reduce from the calculated delivery fee.)
										</th>
										<td>
											<input @input = "calcFee" type = "number" class = "form_control" placeholder = "Deduction Amount" v-model = "editForm['Deduction Amount']">
											<p class = "font-red">{{errorMsg["Deduction Amount"]}}</p>
										</td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
					<tr>
						<th>Delivery Distance to Customer</th>
						<td>
							<input @input = "calcFee" type="number" v-model = "editForm['Delivery Distance']">
							<p class = "font-red">{{errorMsg["Delivery Distance"]}}</p>
						</td>
					</tr>
					<tr>
						<th>Order Total</th>
						<td>
							<input @input = "calcFee" type="number" v-model = "editForm['Order Total']">
							<p class = "font-red">{{errorMsg["Order Total"]}}</p>
						</td>
					</tr>
					<tr>
						<th>Calculation Information</th>
						<td>
							<p v-for = "i in calculationInfo.split('\n')">{{i}}</p>
							<p>{{calculationFormula}}</p>
						</td>
					</tr>
					<tr>
						<th>Total Delivery Fee</th>
						<td>
							{{formatPrice(delFee, "RM")}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

	</div>
</template>


<script>
import imageCompression from 'browser-image-compression';
import XLSX from "xlsx";
var md5 = require('md5');
var uuid = require('uuid/v5');
var dbPath = "";
var docID = "";
var itemTemplate;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"Min Delivery Distance","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Min Delivery Distance","singleView":true,"type":"Price"},{"Name":"Max Delivery Distance","checkFun":"posNum","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Max Delivery Distance","singleView":true,"type":"Price"},{"Name":"Delivery Fee","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Delivery Fee","singleView":true,"type":"Price"},{"Name":"Delivery Rate","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Delivery Rate","singleView":true,"type":"Price"},{"Name":"Minimum Order","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Minimum Order","singleView":true,"type":"Price"},{"Name":"Deduction Amount","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Deduction Amount","singleView":true,"type":"Price"},{"Name":"Delivery Distance","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Delivery Distance","singleView":true,"type":"Price"},{"Name":"Order Total","checkFun":"nonNeg","children":[],"defaultValue":"0","inputType":"number","manyView":true,"max":"Inf","min":"-Inf","placeholder":"Order Total","singleView":true,"type":"Price"}];
		var response = myInput.init(itemTemplate);
		return{
			// FORM
			addForm: {},
			editForm: response.output,
			viewForm: {},
			errorMsg: response.errorMsg,

			// NAV VARIABLES
			editing: false,
			loaded: false,

			// PLACEHOLDER
			oriItem: {},
			delFee: 0,
			calculationInfo: "",
			calculationFormula: "",
		}
	},

	firestore(){
		dbPath = "business/" + this.$route.params.businessID + "/settings";
		docID = "preOrderSetting";
		this.editForm = myInput.editMain(this.$parent.preOrderSetting, itemTemplate).output;
		this.editing = true;
		this.calcFee();
	},

	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		calcFee(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			this.calculationInfo = "";
			this.calculationFormula = "";
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				var form = response.output;
				var delFee = 0;
				if (form["Delivery Distance"] > form["Max Delivery Distance"]){
					this.calculationInfo += "This distance is beyond your delivery range and cannot be placed.\n";
				}
				else{
					if (form["Delivery Distance"] < form["Min Delivery Distance"]){
						this.calculationInfo += "This distance is within the minimum distance therefore only the base fee is included.\n";
						delFee = form["Delivery Fee"];
						this.calculationFormula += "Base Fee (" + myPrice.display(form["Delivery Fee"]) + ")";
					}
					else{
						this.calculationInfo += "This distance is beyond the minimum distance, the formula is used.\n";
						var roundedDistance = Math.ceil(2*(form["Delivery Distance"] - form["Min Delivery Distance"]))/2;
						delFee = form["Delivery Fee"] + form["Delivery Rate"]*roundedDistance;
						this.calculationFormula += "Base Fee (" + myPrice.display(form["Delivery Fee"]) + ") + [Delivery Rate (" + myPrice.display(form["Delivery Rate"]) + ")] x [Rounded Distance (" + roundedDistance + ")]";
					}
					if (form["Order Total"] >= form["Minimum Order"]){
						this.calculationInfo += "The order total is greater than the minimum required order for reduced/free delivery.\n";
						if (delFee < form["Deduction Amount"]){
							this.delFee = 0;
							this.calculationInfo += "The delivery fee is less than the deduction amount, the delivery is now free.\n";
							this.calculationFormula += " - Discount (" + myPrice.display(delFee) + ") ";
						}
						else{
							this.delFee = delFee - form["Deduction Amount"];
							this.calculationFormula += " - Discount (" + form["Deduction Amount"] + ") ";
							this.calculationInfo += "The delivery fee is greater than the deduction amount, the delivery is only reduced.\n";
						}
						this.calculationFormula = "Total (" + myPrice.display(this.delFee) +") = " + this.calculationFormula;
					}
					else{
						this.delFee = delFee;
						this.calculationFormula = "Total (" + myPrice.display(this.delFee) +") = " + this.calculationFormula;
					}
				}
			}
		},
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDate(input, mode);
		},
		formatDateTime(input){
			var mode = {
				sequence: "d m y",
				monthMode: 2,
			}
			return myDate.displayDateTime(input, mode, {sequence: "hh:mm"});
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//------------------------------ UPDATE ------------------------------//
		editSubmit(){
			var response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				delete response.output["Delivery Distance"];
				delete response.output["Order Total"];
				delete response.output[".key"];
				myFB.updateDoc(dbPath, response.output, docID, this, "Updating " + docID + "..." , docID + " updated!");
			}
		},
		//----------------------------- BACK -----------------------------//
		cancel(){
			this.viewing = false;
			this.adding = false;
			this.editing = false;
			this.sorting = false;
		},
		addElement(elementName, elementIndex){
			var temp;
			itemTemplate.forEach(r=>{
				if (r.Name == elementName){
					temp = r.children;
				}
			})
			var newElement = myInput.init(temp);
			if (this.adding){
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.addForm[elementName].push(newElement.output);
			}
			else{
				this.errorMsg[elementName].push(newElement.errorMsg);
				this.editForm[elementName].push(newElement.output);
			}
		},
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Manager/DeliveryFeeCalculator.vue